import { render, staticRenderFns } from "./ReviewsItem.vue?vue&type=template&id=1133b378&scoped=true&"
import script from "./ReviewsItem.vue?vue&type=script&lang=js&"
export * from "./ReviewsItem.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsItem.vue?vue&type=style&index=0&id=1133b378&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1133b378",
  null
  
)

export default component.exports